module.exports = __webpack_public_path__ + "static/dev-9e2d15d22a96d1a4524d7bebc52b4889.svg";